export default __webpack_public_path__ + "static/media/meeting.7bc0777f.jpg";